module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_David_CR-p-500-5d4b00e85363f03dbf8251b0f5fa6329.jpg";